import type { SeasonEntity, SeasonEntityResources } from "~types/seasonEntity";
import type { SeasonEntityTransformed } from "../types/seasonEntityTransformed";

export const transformSeasonEntity = (item: SeasonEntity, resources: SeasonEntityResources | undefined): SeasonEntityTransformed => {
  const entity = resources?.entities?.[item.entity.id ?? item.entityId];
  const conferenceId = item.conference?.id ?? item.conferenceId ?? "";
  const divisionId = item.division?.id ?? item.divisionId ?? "";
  const conference = resources?.conferences?.[conferenceId];
  const division = resources?.divisions?.[divisionId];
  const season = resources?.seasons?.[item.season?.id ?? item.seasonId];

  return {
    ...item,
    entity,
    conference,
    division,
    season,
  };
};
